const updColeccNO_ID = (creaColecc, createColecc) => {
  let numDocCRUD = 0
  let totDocCRUD = creaColecc.length
  let argsCrud = []
  let crudColecc = []

  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'NO_CRUD'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(createColecc)
  }
  
  creaColecc.forEach((elemento1, ii) => {
    argsCrud[numDocCRUD] = elemento1
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

    numDocCRUD += 1
  })

  let updColecc = {crudColecc, argsCrud, totDocCRUD}
  return(updColecc)
}

export default updColeccNO_ID
